export default "https://assets-v2.scaler.com/packs/files/9_months_nudge.c414d4.webp";